module.exports = __webpack_public_path__ + "media/images/lp-flow-step-1@2x-78da0862cfd90d27b3590f9c6a983b20.png";